import React from "react";
type LogoProps = {
  tone?: "dark" | "light";
};
export function Logo({
  tone = "dark"
}: LogoProps) {
  const color = tone === "light" ? "text-white" : "text-navy";
  return <div className={`inline-flex items-center gap-2.5 ${color}`} data-id="element-39" data-mp="3q9kyos1rcqj7">
      <span className="flex h-10 w-10 items-end justify-center gap-[3px] rounded-xl bg-navy pb-2.5" aria-hidden="true" data-id="element-40" data-mp="3qbe8uhbkxsvy">
        <span className="h-4 w-[3px] rounded-full bg-teal-light" data-id="element-41" data-mp="3v6bjttsf6cbh" />
        <span className="h-6 w-[3px] rounded-full bg-white" data-id="element-42" data-mp="mtdxcs6tf5dl" />
        <span className="h-5 w-[3px] rounded-full bg-teal-light" data-id="element-43" data-mp="rs7csq5nx6ge" />
      </span>
      <span className="text-[15px] font-bold tracking-[0.18em]" data-id="element-44" data-mp="dsg3v3u06g99">RHINOPLASTY LAB™</span>
    </div>;
}